import { Form, Modal, ModalProps } from 'antd';
import React from 'react';
import GroupsGeneralForm from '../GroupsGeneralForm';
import { CreateGroupRequest } from '@/core/domain/operational/Groups/Groups.types';
import { useCreateGroup } from '@/core/domain/operational/Groups/Groups.hooks';
import { useHistory } from 'react-router-dom';

interface Props extends ModalProps {
  onCancel: VoidFunction;
}

const GroupCreateModal: React.FC<Props> = ({ onCancel, ...props }) => {
  const history = useHistory();

  const [form] = Form.useForm<CreateGroupRequest>();

  const mutation = useCreateGroup();

  const handleOk = async () => {
    try {
      const values = await form.validateFields();

      const response = await mutation.mutateAsync(values);

      history.push(`/app/operational/inventory/groups/${response.id}`);
    } catch {}
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title="Criação do grupo"
      width={800}
      onCancel={handleCancel}
      onOk={handleOk}
      confirmLoading={mutation.isLoading}
      okText="Criar"
      {...props}
    >
      <GroupsGeneralForm form={form} />
    </Modal>
  );
};

export default GroupCreateModal;
